import {useEffect, useState} from "react";
import {Repositories} from "../repositories/Repositories";
import {Stat} from "../repositories/stat/Stat";

const REFRESH_TIME = 60000;

const useStatListenerHook = (): Stat[] => {
    const [stats, setStats] = useState<Stat[]>([]);

    useEffect(() => {
        fetchHeatPoints();
        const intervalId = setInterval(fetchHeatPoints, REFRESH_TIME);
        return () => clearInterval(intervalId);
    }, []);

    const fetchHeatPoints = (): void => {
        Repositories.state.fetchStats()
            .then((stats) => setStats(stats));
    };

    return stats;
};

export default useStatListenerHook;
